import BaseAnnotationLayer from "./BaseAnnotationLayer";

class MagicToolLayer extends BaseAnnotationLayer {
	id = "MagicTool";
	label = "Magic Tool Layer";
	tools = [];
}

export default MagicToolLayer;
